import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react';

export function SideListHeader({
  children,
  ...props
}: PropsWithChildren<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
>) {
  return (
    <div
      {...props}
      style={{
        textAlign: 'center',
        fontWeight: 'bold',
        padding: '5px',
        borderBottom: '1px solid #ccc',
        marginBottom: '5px',
        ...props.style,
      }}>
      {children}
    </div>
  );
}
